import React, { useState, useEffect } from "react";
import { getProductClassM } from "../../../http/api/ProductClassMAPI";
import { Select, MenuItem, FormControl } from "@mui/material";

const ProductClassMSelect = ({ onChange, value, productClassLId }) => {
  const [listProductClassM, setListProductClassM] = useState([]);
  const [selectedValue, setSelectedValue] = useState(value || "-1");

  async function getListProductClassM() {
    if (!productClassLId || productClassLId <= 0) return;
    let response = await getProductClassM({
      productClassLId,
    });
    setListProductClassM(response.listProductClassMInfo);
  }

  useEffect(() => {
    getListProductClassM();
  }, [productClassLId]);

  useEffect(() => {
    setSelectedValue(value);
  }, [value]);

  const handleSelectionChange = (event) => {
    const newValue = event.target.value;
    setSelectedValue(newValue);
    if (onChange) {
      onChange(event);
    }
  };

  return (
    <>
      <Select
        value={selectedValue}
        onChange={handleSelectionChange}
        sx={{ width: 400, marginInline: 1 }}
      >
        <MenuItem key="unselected" value="-1">
          [未選択]
        </MenuItem>
        {listProductClassM.map((item) => (
          <MenuItem key={item.productClassMId} value={item.productClassMId}>
            {item.productClassMName}
          </MenuItem>
        ))}
      </Select>
    </>
  );
};

export default ProductClassMSelect;
